// @flow

import { useState, useEffect, useCallback } from 'react';
import { type IncomingPayment, fetchIncomingPayment } from '@tectonics/prs/incoming-payment';
import { initReactIntl } from '@tectonics/translate';
import { useControllerContext, useLocalTenancyAsTenant } from './context';
import { useLanguage } from '@tectonics/controller/language/LanguageContext';

export function useFetchIncomingPayment(setIncomingPayment: (IncomingPayment) => void): [bool, ?Error, () => void] {
  const [fetching, setFetching] = useState<boolean>(true);
  const [fetchingError, setFetchingError] = useState<?Error>(null);
  const { hash } = useControllerContext();
  const tenant = useLocalTenancyAsTenant();
  const [reloadCounter, setReloadCounter] = useState<number>(0);
  const requestReload = useCallback(() => {
    setReloadCounter(reloadCounter => reloadCounter + 1);
  }, []);
  const { addCountry } = useLanguage();

  useEffect(() => {
    setFetching(true);
    setFetchingError(null);

    (async () => {
      try {
        const incomingPayment = await fetchIncomingPayment(hash, tenant);
        const { country } = incomingPayment;
        await addCountry(country);
        setIncomingPayment(incomingPayment);
        await initReactIntl(country);
        setFetching(false);
      } catch(e) {
        setFetchingError(e);
        setFetching(false);
      }
    })();
  }, [hash, setIncomingPayment, setFetching, tenant, reloadCounter]);

  return [fetching, fetchingError, requestReload];
}
